import moment from 'moment'

export const purchaseOrder = {
    id: '',
    transactionNo: '',
    date: moment().format('YYYY-MM-DD'),
    vendorId: '',
    vendorCode: '',
    vendorName: '',
    termOfPayment: 0,
    isTaxable: 0,
    description: '',
    createdAt: '',
    createdBy: ''
}

export const purchaseOrderDetail = {
    id: '',
    purchaseOrderId: '',
    productId: '',
    productCode: '',
    productName: '',
    productBrand: '',
    qty: 0,
    price: 0,
    discount: 0,
    ppn: 0,
    pph: 0
}